import * as React from "react";
const SvgSwitchBasicDisabled = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={56} height={40} fill="none" {...props}>
    <rect width={52} height={32} x={2} y={4} fill="#EAEAEA" rx={16} />
  </svg>
);
export default SvgSwitchBasicDisabled;
